export const LOAD_CLINIC_LOCATION_TYPES = "LOAD_CLINIC_LOCATION_TYPES";

export const LOAD_CLINIC_LOCATION_TYPES_SUCCESS = "LOAD_CLINIC_LOCATION_TYPES_SUCCESS";
